import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

const TimeKeeperAtom = (props) => {
  const { isOpen, toggle } = props;

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static" className="edit_time_popup">
      <ModalBody>
      </ModalBody>
    </Modal>
  );
};

export default TimeKeeperAtom;
